export { ViewCustomPage } from './ui/view-custom-page';
